import React from "react";
import { Articles } from "../types/article";
import { Group } from "../types/groups";
import { ArticlesImagesOverview } from "./ArticlesImagesOverview";
import { CenterContainer, RightContainer } from "../styles/styles";
import { RightArrow } from "../Atoms/Icons/RightArrow";
import { Text } from "../Atoms/Text";
import styled from "styled-components";
import { useTranslation } from "@coworker/locales";

interface ArticleGroupItemProps {
  group: Group;
  articles: Articles;
}

const ArticleGroupRowContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 1px solid var(--grey200);
  margin-bottom: 8px;
  padding: 16px;
`;

export const ArticleGroupItem = ({
  articles,
  group,
}: ArticleGroupItemProps) => {
  const { t } = useTranslation();
  const articlesInGroup = articles.filter(
    (article) => article.groupId === group.id
  );
  const articleCount = articlesInGroup.length;
  const pieceCount = articlesInGroup.reduce(
    (accumulator, currentValue) => (accumulator += currentValue.nbrArticles),
    0
  );

  return (
    <ArticleGroupRowContainer>
      <CenterContainer $centerText={false}>
        <Text text={group.name} bold />
        <Text
          text={`${t("countArticlesString", {
            count: articleCount,
          })}, ${t("piecesCountString", { count: pieceCount })}`}
        />
        {articleCount > 0 && (
          <ArticlesImagesOverview articles={articlesInGroup} />
        )}
      </CenterContainer>
      <RightContainer>
        <RightArrow />
      </RightContainer>
    </ArticleGroupRowContainer>
  );
};
